import classes from "./premium-perks.module.css";
import cx from "classnames";
import UrgentHiring from "../UrgentHiring";
import MiniBoostTag from "../minBoostTag";

function PremiumPerksMobile(props) {
  const mobilePerksData = [
    {
      heading: "Premium Job",
      headingIconSrc: "/hire/flash.svg",
      imgClass: classes.hiringFaster,
      headingText: "For Hiring Faster",
      jobVisibilityText: "Boosted job visibility",
      directApplies: "High number of direct applies",
      directAppliesSrc: "/hire/urgent-hiring-check.svg",
      dbMatchesLabel: "High number of database matches",
      dbMatchesSrc: "/hire/urgent-hiring-check.svg",
      urgentHiring: "Highlighted with an urgent hiring tag",
      urgentHiringSrc: "/hire/urgent-hiring-check.svg",
      isUrgentHiringTip: true
      // jobBoostLabel: "Get 1 job boost",
      // boostTip: true
    },
    {
      heading: "Basic Job",
      headingIconSrc: "/hire/diamond.svg",
      imgClass: cx(classes.starter, classes.hiringFaster),
      headingText: "Starter",
      jobVisibilityText: "Boosted job visibility",
      directApplies: "Low number of direct applies",
      directAppliesSrc: "/hire/gray-circle-tick.svg",
      dbMatchesLabel: "Low number of database matches",
      dbMatchesSrc: "/hire/gray-circle-tick.svg",
      urgentHiring: "Highlighted with an urgent hiring tag",
      urgentHiringSrc: "/hire/red-circle-tick.svg",
      isUrgentHiringTip: false
      // jobBoostLabel: "Get 1 job boost",
      // boostTip: false
    }
  ];

  return (
    <div className={classes.root}>
      <div className={classes.heading}>Why post a Premium job?</div>
      <div className={classes.dataContainer}>
        <img
          src="/hire/pink-diamond.svg"
          width={28}
          height={28}
          alt="pink diamond"
        />
        {mobilePerksData.map((data, index) => (
          <>
            <div
              className={
                !data.isUrgentHiringTip
                  ? cx(classes.marginBtm, classes.perksHeading)
                  : cx(classes.perksHeading)
              }
            >
              {data.heading}
            </div>
            <div className={data.imgClass}>
              <img
                src={data.headingIconSrc}
                width={13}
                height={13}
                alt={`icon ${index}`}
              />
              {data.headingText}
            </div>

            <div
              className={
                !data.isUrgentHiringTip
                  ? cx(classes.opacity, classes.perkDataClass)
                  : cx(classes.urgentHiringCont, classes.perkDataClass)
              }
            >
              <img
                src={data.urgentHiringSrc}
                width={16}
                height={16}
                alt={`icon ${index}`}
                className={classes.contentIcon}
              />
              {data.jobVisibilityText}
            </div>
            <div className={classes.perkDataClass}>
              <img
                src={data.directAppliesSrc}
                width={16}
                height={16}
                alt={`icon ${index}`}
                className={classes.contentIcon}
              />
              {data.directApplies}
            </div>
            <div className={classes.perkDataClass}>
              <img
                src={data.dbMatchesSrc}
                width={16}
                height={16}
                alt={`icon ${index}`}
                className={classes.contentIcon}
              />
              {data.dbMatchesLabel}
            </div>
            <div
              className={
                !data.isUrgentHiringTip
                  ? cx(classes.opacity, classes.perkDataClass)
                  : cx(classes.urgentHiringCont, classes.perkDataClass)
              }
            >
              <img
                src={data.urgentHiringSrc}
                width={16}
                height={16}
                alt={`icon ${index}`}
                className={classes.contentIcon}
              />
              {data.urgentHiring}
              {data.isUrgentHiringTip && <UrgentHiring />}
            </div>
            {/* <div
              className={
                !data.boostTip
                  ? cx(classes.opacity, classes.perkDataClass)
                  : cx(
                      classes.urgentHiringCont,
                      classes.perkDataClass,
                      "flex items-center"
                    )
              }
            >
              <img
                src={data.urgentHiringSrc}
                width={16}
                height={16}
                alt={`icon ${index}`}
                className={classes.contentIcon}
              />
              {data.jobBoostLabel}
              {data.boostTip && (
                <div className="ml-2">
                  <MiniBoostTag boostContent tipClass={classes.tipClass} />
                </div>
              )}
            </div> */}

            {index === 0 ? <div className={classes.border} /> : null}
          </>
        ))}
      </div>
    </div>
  );
}

export default PremiumPerksMobile;
